<template>
  <div class="relative">
    <div
        @click="dropdownOpen = !dropdownOpen"
        class="cursor-pointer flex items-center relative"
    >
      <div class="header__notify">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <use xlink:href="@/assets/v2/img/sprite.svg#icon__bell"></use>
        </svg>
      </div>
      <div v-if="notReadCount"
           class="absolute top-0 font-medium right-0 text-xs leading-none bg-red-500 rounded-full h-5 w-5 flex justify-center items-center text-white">
        {{ notReadCount }}
      </div>
    </div>

    <div
        v-show="dropdownOpen"
        @click="dropdownOpen = false"
        class="fixed inset-0 z-40 w-full h-full bg-black opacity-50"
    ></div>

    <transition
        enter-active-class="transition duration-150 ease-out transform"
        enter-from-class="scale-95 opacity-0"
        enter-to-class="scale-100 opacity-100"
        leave-active-class="transition duration-150 ease-in transform"
        leave-from-class="scale-100 opacity-100"
        leave-to-class="scale-95 opacity-0"
    >
      <div
          v-show="dropdownOpen"
          class="absolute right-0 z-50 w-128 mt-2 bg-white rounded-md shadow-xl"
      >
        <div class="flex items-baseline justify-between px-3 mt-2 pb-2 border-b">
          <h3 class="text-lg font-medium">{{ $lang.app.NOTIFICATIONS }}</h3>
          <button class="underline text-sm text-blue-500"
                  @click="readAll">{{ $lang.app.MARK_AS_READ }}
          </button>
        </div>
        <div id="infinite-list" class="custom-scrollbar pb-4">
          <div v-if="!notifications.length" class="text-center p-3">
            {{ $lang.app.NOTIFICATIONS_EMPTY }}
          </div>
          <div v-for="notification in notifications" :key="notification.id"
               class="px-2 py-3 flex items-center border-t first:border-t-0 cursor-pointer"
               :class="{'font-medium': !notification.read}"
               @click="redirect(notification)">
            <div class="header__notify">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__bell"></use>
              </svg>
            </div>
            <div>
              <div class="leading-tight">{{ notification.content }}</div>
              <div class="text-gray-500">{{ $moment(notification.createdAt).format('DD.MM.YYYY HH:mm') }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import notificationApi from "../../api/applicant/notification";
import {getValueByKey as notificationTypesGetValue} from "../../helpers/constants/notificationTypes";

export default {
  data() {
    return {
      dropdownOpen: false,
      notReadCount: null,
      page: 1,
      notifications: [],
    }
  },
  mounted() {
    this.loadCount()
    this.loadNotifications()

    let listElm = document.querySelector('#infinite-list');
    listElm.addEventListener('scroll', () => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.page++;
        this.loadNotifications()
      }
    });
  },
  methods: {
    notificationTypesGetValue,
    loadCount() {
      notificationApi.count().then(res => {
        this.notReadCount = res.notReadCount > 99 ? 99 : res.notReadCount
      })
    },
    loadNotifications() {
      notificationApi.list({
        limit: 10,
        page: this.page
      }).then(res => {
        this.notifications = this.notifications.concat(res.list)
      })
    },
    redirect(notification) {
      notificationApi.read(notification.id).then(() => {
        this.loadCount()
        this.notifications[this.notifications.findIndex(item => item.id === notification.id)].read = true
        if (notification.type === this.notificationTypesGetValue('IN_PROCESS_REMARKS')) {
          this.$router.push({
            name: "ApplicantApplicationDocumentsVersionDetail",
            params: {
              applicationId: notification.payload.applicationId,
              documentsVersionId: notification.payload.versionId
            },
          });
        }
        if (notification.type === this.notificationTypesGetValue('ADDITIONAL_AGREEMENT_REMARKS')) {

          // this.$router.push(`/applicant/application/${notification.payload.applicationId}/agreement/detail#additional-agreement-${notification.payload.additionalAgreementId}`)

          this.$router.push({
            name: "ApplicantApplicationAgreementDetail",
            params: {
              applicationId: notification.payload.applicationId
            },
            query: {
              additionalAgreementId: notification.payload.additionalAgreementId
            }
          });
        }
        this.dropdownOpen = false
      })
    },
    readAll() {
      notificationApi.readAll().then(() => {
        this.loadCount()
        this.notifications = this.notifications.map(item => ({...item, read: true}))
      })
    }
  }
}
</script>
<style>
#infinite-list {
  max-height: 540px;
  overflow: auto;
}
</style>
